<template>
<v-container fluid>
  <v-layout justify-center wrap>
    <v-flex
      xs12
      class="mb-3"
    >
      <v-toolbar color="#FAFAFA" flat>
      <!--v-toolbar-side-icon @click="$emit('showHideMenu')" ></v-toolbar-side-icon-->
        <v-toolbar-title dark  justify-center>{{mes_atual}}</v-toolbar-title>
        <v-spacer></v-spacer>

    </v-toolbar>
<v-divider></v-divider>

      <v-sheet height="500">
        
        <v-calendar
          ref="calendar"
          v-model="start"
          type="month"
          
          color="primary"
          locale="pt-br"
          v-on:change="changeViewRange"
        ></v-calendar>
      </v-sheet>
    </v-flex>

    <v-flex
      sm4
      xs12
      class="text-sm-left text-xs-center"
    >
      <v-btn @click="$refs.calendar.prev()">
        <v-icon
          dark
          left
        >
          keyboard_arrow_left
        </v-icon>
        ANTERIOR
      </v-btn>
    </v-flex>
    <v-flex
      sm4
      xs12
      class="text-xs-center"
    >
      <!--v-select
        v-model="type"
        :items="typeOptions"
        label="Type"
      ></v-select-->
    </v-flex>
    <v-flex
      sm4
      xs12
      class="text-sm-right text-xs-center"
    >
      <v-btn @click="$refs.calendar.next()">
        Próximo
        <v-icon
          right
          dark
        >
          keyboard_arrow_right
        </v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
  export default {
    data: () => ({
      mes_atual: "",
      start:'2019-04-16',
      startMenu: false,
      events: [
        {
          title: 'Bruna Karla',
          details: 'Single - Toró',
          date: '2018-12-30',
          open: false
        },
        {
          title: 'Bruna Karla',
          details: 'Single - Mentira',
          date: '2018-12-31',
          open: false
        },
        {
          title: 'Thiago Makie',
          details: 'Thiago Makie e turma',
          date: '2019-01-01',
          open: false
        },
        {
          title: 'Meeting',
          details: 'Spending time on how we do not have enough time',
          date: '2019-01-07',
          open: false
        },
        {
          title: '30th Birthday',
          details: 'Celebrate responsibly',
          date: '2019-01-03',
          open: false
        },
        {
          title: 'New Year',
          details: 'Eat chocolate until you pass out',
          date: '2019-01-01',
          open: false
        },
        {
          title: 'Conference',
          details: 'Mute myself the whole time and wonder why I am on this call',
          date: '2019-01-21',
          open: false
        },
        {
          title: 'Hackathon',
          details: 'Code like there is no tommorrow',
          date: '2019-02-01',
          open: false
        }
      ]
    }),

    computed: {
      // convert the list of events into a map of lists keyed by date
      eventsMap () {
        const map = {}
        this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        return map
      }
    },
    methods: {
      open (event) {
        alert(event.title)
      },
      changeViewRange(e){
        console.log(e);
        this.mes_atual = e.start.month+ " / "+e.start.year;
      }
    },
    mounted(){
      var _d = new Date();
      var date_obj = {start:{month:_d.getMonth(), year:_d.getFullYear()}}
      this.start = _d.getFullYear()+"-"+( _d.getMonth() + 1 )+"-"+_d.getDate();
      console.log(this.start);
      this.changeViewRange(date_obj);
    }
  }
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
</style>